const COUNT_KEY = 'my-bandai:screen-windows:count';

export function openTiledWindow(url: string): void {
  const width = 1024;
  const height = 768;
  const availWidth = Math.max(800, window.screen?.availWidth || 1920);
  const availHeight = Math.max(600, window.screen?.availHeight || 1080);

  let count = 0;
  try {
    count = Number(localStorage.getItem(COUNT_KEY) || '0') || 0;
    localStorage.setItem(COUNT_KEY, String(count + 1));
  } catch {
    // ignore storage errors
  }

  const stepWidth = width + 32;
  const stepHeight = height + 40;
  const cols = Math.max(1, Math.floor(availWidth / stepWidth));
  const col = count % cols;
  const row = Math.floor(count / cols);
  const left = 16 + col * stepWidth;
  const top = Math.min(8 + row * stepHeight, Math.max(8, availHeight - height));

  open(url, '_blank', `left=${left},top=${top},width=${width},height=${height}`);
}
